<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4703_6860)">
      <path
        d="M12.7099 6.2479C13.5675 6.2479 14.6426 5.66811 15.2827 4.89507C15.8625 4.19449 16.2853 3.21611 16.2853 2.23773C16.2853 2.10486 16.2732 1.97199 16.249 1.86328C15.2948 1.89952 14.1473 2.50346 13.4588 3.31274C12.9153 3.92876 12.4201 4.89507 12.4201 5.88553C12.4201 6.03048 12.4442 6.17542 12.4563 6.22374C12.5167 6.23582 12.6133 6.2479 12.7099 6.2479ZM9.69024 20.8633C10.8619 20.8633 11.3813 20.0782 12.8428 20.0782C14.3285 20.0782 14.6546 20.8391 15.9592 20.8391C17.2395 20.8391 18.0971 19.6554 18.9064 18.4958C19.8123 17.1672 20.1867 15.8626 20.2109 15.8023C20.1264 15.7781 17.6743 14.7756 17.6743 11.9612C17.6743 9.52126 19.607 8.42209 19.7157 8.33753C18.4353 6.50155 16.4906 6.45324 15.9592 6.45324C14.5218 6.45324 13.3501 7.32291 12.6133 7.32291C11.8161 7.32291 10.7653 6.50155 9.52114 6.50155C7.15369 6.50155 4.75 8.45832 4.75 12.1544C4.75 14.4494 5.64383 16.8773 6.74301 18.4475C7.68516 19.7762 8.50652 20.8633 9.69024 20.8633Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4703_6860">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.261719)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
